export default {
      id: "icon--wtw-jewellery-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wtw-jewellery-usage",
      toString: function () {
        return this.url;
      }
    }